export default {"src":"/_next/static/media/segurize-white.27da47bf.svg","height":90,"width":124};